import { Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import AsyncAutocomplete from '../comman/AsyncAutoComplete';
import { apiRequest } from '../../utils/config/apiRequest';
import { apiUrl } from '../../utils/endPoints/apiUrl';

export default function ComplaintStatus({ ticketId, OnSelect = () => {} }) {

  const [selectStatus, setSelectedStatus] = useState(null);

  const statusOptions = [
    { label: "Open", value: "OPEN" },
    { label: "In Progress", value: "IN_PROGRESS" },
    { label: "Resolved", value: "RESOLVED" },
    { label: "Closed", value: "CLOSED" },
  ];

  const handleStatusChange = async (option) => {
    if (!option) return;

    const { status } = await apiRequest({
      method: 'PUT',
      endUrl: apiUrl.complaints.complaintsStatus(ticketId), 
      body: {
        currentStatus: option.value,
      },
      showMsg: true,
    });

    if (status) {
      setSelectedStatus(option);
      OnSelect();
    }
  };

  return (
    <AsyncAutocomplete
      prefetch
      prefetchDependency={[ticketId]}
      label="Status"
      placeholder="Select Complaints Status"
      value={selectStatus}
      onChange={handleStatusChange}
      fetchOptions={async () => statusOptions}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(o, v) => o.value === v.value}
      renderOption={(props, option) => (
        <li {...props} key={option.value}>
          <Stack>
            <Typography variant="subtitle2">
              {option.label}
            </Typography>
          </Stack>
        </li>
      )}
    />
  );
}
